import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
var useExpandLogic = function useExpandLogic() {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    expandedItems = _useState2[0],
    setExpandedItems = _useState2[1];
  var handleExpand = function handleExpand(item) {
    var index = expandedItems.indexOf(item);
    var newCheckedItems = index >= 0 ? [].concat(_toConsumableArray(expandedItems.slice(0, index)), _toConsumableArray(expandedItems.slice(index + 1))) : [].concat(_toConsumableArray(expandedItems), [item]);
    setExpandedItems(newCheckedItems);
    return index >= 0;
  };
  return {
    handleExpand: handleExpand,
    expandedItems: expandedItems
  };
};
export default useExpandLogic;